'use client';

import { Box, VStack, HStack } from '@terra/ui-styled-system';
import { Text } from '../../../../components/styled/text';
import { SmartValue } from './EntityBadge';

type EndpointDetailsRendererProps = {
  data: Record<string, unknown>;
};

export function EndpointDetailsRenderer({
  data,
}: EndpointDetailsRendererProps) {
  const entries = Object.entries(data).filter(
    ([key]) =>
      key !== '_id' &&
      key !== '__v' &&
      key !== 'id' &&
      key !== 'endpointId' &&
      key !== 'credentialId',
  );

  return (
    <Box
      width="100%"
      borderWidth="1px"
      borderColor="border.subtle"
      borderRadius="md"
      p={3}
      bg="bg.canvas"
    >
      <VStack gap={2} alignItems="stretch">
        {entries.map(([key, value]) => (
          <HStack key={key} gap={2} alignItems="flex-start" width="100%">
            <Text
              fontSize="xs"
              color="fg.muted"
              fontWeight="medium"
              minWidth="120px"
              flexShrink={0}
            >
              {key}:
            </Text>
            <Box flex={1}>
              <SmartValue
                fieldName={key}
                value={value}
                fallback={(val) => {
                  if (typeof val === 'object' && val !== null) {
                    return (
                      <Text fontSize="xs" fontFamily="mono" color="fg.default">
                        {JSON.stringify(val, null, 2)}
                      </Text>
                    );
                  }
                  return (
                    <Text fontSize="xs" color="fg.default">
                      {String(val)}
                    </Text>
                  );
                }}
              />
            </Box>
          </HStack>
        ))}
      </VStack>
    </Box>
  );
}
